import React from 'react';

const StatusModal = ({ application, onClose, onDownload }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold"
        >
          ×
        </button>

        <div className="mb-6">
          <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-gray-800 text-center mb-2">
            Application Approved!
          </h3>
          <p className="text-center text-gray-600">
            Your visa application has been successfully processed.
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div className="border-b pb-3">
            <p className="text-sm text-gray-500 mb-1">Name</p>
            <p className="text-lg font-semibold text-gray-800">{application.name}</p>
          </div>

          <div className="border-b pb-3">
            <p className="text-sm text-gray-500 mb-1">Application ID</p>
            <p className="text-lg font-semibold text-gray-800">{application.applicationId}</p>
          </div>

          <div className="border-b pb-3">
            <p className="text-sm text-gray-500 mb-1">Nationality</p>
            <p className="text-lg font-semibold text-gray-800">{application.nationality}</p>
          </div>

          <div className="border-b pb-3">
            <p className="text-sm text-gray-500 mb-1">Passport Number</p>
            <p className="text-lg font-semibold text-gray-800">{application.passportNumber}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500 mb-1">Date of Birth</p>
            <p className="text-lg font-semibold text-gray-800">{formatDate(application.dob)}</p>
          </div>
        </div>

        <button
          onClick={onDownload}
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transform transition hover:scale-105"
        >
          Download Document
        </button>
      </div>
    </div>
  );
};

export default StatusModal;


